import { render, staticRenderFns } from "./RemoveManagerContractorRequestNew.vue?vue&type=template&id=156a34de"
import script from "./RemoveManagerContractorRequestNew.vue?vue&type=script&lang=ts"
export * from "./RemoveManagerContractorRequestNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156a34de')) {
      api.createRecord('156a34de', component.options)
    } else {
      api.reload('156a34de', component.options)
    }
    module.hot.accept("./RemoveManagerContractorRequestNew.vue?vue&type=template&id=156a34de", function () {
      api.rerender('156a34de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/RemoveManagerContractorRequestNew.vue"
export default component.exports